import React, { useEffect, useState, useRef } from "react";
import {
  Modal,
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  CircularProgress,
  Tabs,
  Tab,
} from "@mui/material";

import DataTable from "../DataTable/DataTable";
import { IoClose } from "react-icons/io5";
import axios from "axios";
import MoreDetailsModal from "./MoreDetailsModal";
import { Tooltip, IconButton } from "@mui/material";
import MoreDetailsModalLocation from "./MoreDetailsModalLocation";
import { AiOutlineInfoCircle } from "react-icons/ai";
import MatchedSofDocsModal from "../Dashboard/MatchedSofDocsModal";
import { fetchMatchedSofDocs } from "../../api/dashboardApi";
import toast, { Toaster } from 'react-hot-toast';
import { useNavigate, useSearchParams } from "react-router-dom";
import { useErrorToast } from "../../hooks/useErrorToast";
import { Dialog } from "@mui/material";
import GroupedServicesDetailsModal from "../Dashboard/GroupedServicesDetailsModal";
import ContractAmountBreakdownModal from "../Dashboard/ContractAmountBreakdownModal";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      style={{
        flex: value === index ? 1 : 0,
        display: value === index ? "flex" : "none",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      {value === index && (
        <Box sx={{ p: 1, flex: 1, overflowY: "auto" }}>{children}</Box>
      )}
    </div>
  );
}

const Discrepancy = ({
  open,
  setOpen,
  discrepancyData,
  circuitTotals,
  invoiceNo,
  selectedColumn,
  groupedServices,
}) => {
  const navigate = useNavigate();
  const showError = useErrorToast();
  const [searchParams] = useSearchParams();

  // console.log("Discrepancy Component circuitTotals:", circuitTotals);
  // console.log("Discrepancy Component groupedServices:", groupedServices);

  const [moreModalOpen, setMoreModalOpen] = useState(false);
  const [invoiceDetails, setInvoiceDetails] = useState(null);
  const [invoiceDetailsDisc, setInvoiceDetailsDisc] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingDocRowId, setLoadingDocRowId] = useState(null);
  const dataTableRef = useRef(null);
  const circuitTableRef = useRef(null);
  const groupedTableRef = useRef(null);

  const [sofModalOpen, setSofModalOpen] = useState(false);
  const [sofModalData, setSofModalData] = useState(null);
  const [sofModalLoading, setSofModalLoading] = useState(false);
  const [unresolvedContractModalOpen, setUnresolvedContractModalOpen] = useState(false);

  const handleClassificationClick = async (serviceId, invoiceId) => {
    if (!serviceId || !invoiceId) return;
    setSofModalOpen(true);
    setSofModalLoading(true);
    try {
      const data = await fetchMatchedSofDocs(serviceId, invoiceId);
      setSofModalData(data);
    } catch (err) {
      console.error("Failed to fetch matched SOF docs", err);
      setSofModalData({ status: false, msg: "Failed to fetch data." });
    } finally {
      setSofModalLoading(false);
    }
  };

  const [loadingLocRowId, setLoadingLocRowId] = useState(null);
  const [loadingDisRowId, setLoadingDisRowId] = useState(null);
  const [openBreakdown, setOpenBreakdown] = useState(false);
  const [breakdownData, setBreakdownData] = useState({});
  const [tabValue, setTabValue] = useState(0);
  const [isGroupedDetail, setIsGroupedDetail] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setInvoiceDetailsDisc([]);
    setOpen(false);
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  // Pagination for main table

  useEffect(() => {
    if (open) {
       setTabValue(0);
    }
    if (!open) {
      setInvoiceDetailsDisc([]);
    }
  }, [open]);

  const fetchInvoiceDetails = async (docId, rowId) => {
      setLoadingDocRowId(rowId);
    try {
      const token = localStorage.getItem("tokenInv");
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/get-invoice-details-by-doc/${docId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "ngrok-skip-browser-warning": "true",
          },
        }
      );
      setInvoiceDetails(response.data.data);
      setMoreModalOpen(true);
    } catch (error) {
      if (error.response.status === 401) {
        showError("Session Expired! Please Login");
        localStorage.removeItem("tokenInv");
        localStorage.removeItem("roleInv");
        navigate("/");
      } else {
        showError(error?.response?.data?.error || "Something went wrong. Please try again.");
        // toast.error(
        //   error.response.data.error || "Something went wrong. Please try again."
        // );
      }
    } finally {
    setLoadingDocRowId(null);
  }
  };

  const [moreModalOpenLocation, setMoreModalOpenLocation] = useState(false);
  const [invoiceDetailsLocation, setInvoiceDetailsLocation] = useState(null);

  const fetchInvoiceDetailsLocation = async (locId, rowId) => {
      setLoadingLocRowId(rowId);
    try {
      const token = localStorage.getItem("tokenInv");
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/get-invoice-details-by-location/${locId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "ngrok-skip-browser-warning": "true",
          },
        }
      );
      setInvoiceDetailsLocation(response.data.data);
      setMoreModalOpenLocation(true);
    } catch (error) {
      if (error.response.status === 401) {
        showError("Session Expired! Please Login");
        localStorage.removeItem("tokenInv");
        localStorage.removeItem("roleInv");
        navigate("/");
      } else {
        showError(error?.response?.data?.error || "Something went wrong. Please try again.");
        // toast.error(
        //   error.response.data.error || "Something went wrong. Please try again."
        // );
      }
    } finally {
    setLoadingLocRowId(null);
  }
  };

  const fieldMappings = {
    invoice_id: "Invoice Id",
    amount: "Amount",
    charge_type: "Charge Type",
    invoice_date: "Invoice Date",
    location_id: "Location Id",
    service_id: "Service ID",
    service_name: "Service Name",
    total_usd: "Total (USD)",
  };

  const [lastClickedParams, setLastClickedParams] = useState({
    serviceId: null,
    locationId: null,
    chargeType: null,
  });
 
  const fetchDiscrepancyDetails = async (serviceId, locationId, chargeType, invoice_id, rowId) => {
    setLoadingDisRowId(rowId)
    setLoading(true);
    try {
      const token = localStorage.getItem("tokenInv");
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/get-invoice-details-by-service-id/${serviceId}`,
        {
          params: {
            location_id: locationId,
            charge_type: chargeType,
            invoice_id: invoice_id
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setInvoiceDetailsDisc(response.data.data);
      toast.success(response?.data?.message)
    } catch (error) {
      if (error.response.status === 401) {
        showError("Session Expired! Please Login");
        localStorage.removeItem("tokenInv");
        localStorage.removeItem("roleInv");
        navigate("/");
      } else {
        console.log("error",error)
        showError(error?.response?.data?.message || "Something went wrong. Please try again.");
        // toast.error(
        //   error?.response?.data?.message || "Something went wrong. Please try again."
        // );
      }
    } finally {
      setLoading(false);
      setLoadingDisRowId(null)
    } 
  };

  const columns = [
    { field: "service_id", headerName: "Service ID", width: 150 },
    { field: "service_name_y", headerName: "Service Name", width: 150 },
    {
      field: "service_description",
      headerName: "Service Description",
      width: 200,
    },
    {
      field: "doc_id",
      headerName: "Document ID",
      width: 150,
      renderCell: (params) => (
        <Tooltip title="View invoice detail">
          <span
            onClick={() => fetchInvoiceDetails(params.value, params.row.id)}
            style={{
              color: "blue",
              textDecoration: "underline",
              cursor: "pointer",
            }}
          >
            {/* {params.value} */}
            {loadingDocRowId === params.row.id ? (
          <CircularProgress size={16} />
        ) : (
          params.value
        )}
          </span>
        </Tooltip>
      ),
    }, 
    
    { field: "matched_doc_id", headerName: "Matched Doc ID", width: 150 },
    { field: "matched_source", headerName: "Matched Source", width: 150 },
    {
      field: "sof_status",
      headerName: "SOF Status",
      width: 150,
      renderCell: (params) => (
        <span
          style={{
            color: params.value === "Missing" ? "red" : "green",
            fontWeight: 600,
          }}
        >
          {params.value}
        </span>
      ),
    },
    { field: "charge_period", headerName: "Charge Period", width: 150 },
    { field: "charge_type", headerName: "Charge Type", width: 150 },
    { field: "amount", headerName: "Amount", width: 150 },
    { field: "amount_usd", headerName: "Amount (USD)", width: 150 },
    // { field: "contract_amount", headerName: "Contract Amount", width: 150 },
// {
//   field: "contract_amount",
//   headerName: "Contract Amount",
//   width: 150,
//   renderCell: (params) => (
//     <span
//       style={{
//         color: "blue",
//         textDecoration: "underline",
//         cursor: "pointer",
//       }}
//       onClick={() => {
//         const raw = params.row.contract_amount_breakdown;
//         console.log("raw",raw)
//         console.log("params",params)

//         let parsed = {};
//         try {
//           parsed = raw ? JSON.parse(raw) : {};
//         } catch (err) {
//           console.error('Parse error:', err);
//           parsed = {};
//         }

//         setBreakdownData(parsed);
//         setOpenBreakdown(true);
//       }}
//     >
//       {params.value}
//     </span>
//   ),
// },
{
  field: "contract_amount",
  headerName: "Contract Amount",
  width: 150,
  renderCell: (params) => {
    let parsed = {};
    try {
      parsed = params.row.contract_amount_breakdown
        ? JSON.parse(params.row.contract_amount_breakdown)
        : {};
    } catch (err) {
      console.error("Parse error:", err);
      parsed = {};
    }

    // Check if either SOF or Amendment has data
    const hasData =
      (parsed.sof && Array.isArray(parsed.sof) && parsed.sof.length > 0) ||
      (parsed.amendment && Array.isArray(parsed.amendment) && parsed.amendment.length > 0);

    return (
      <span
        style={{
          color: hasData ? "blue" : "gray",
          textDecoration: hasData ? "underline" : "none",
          cursor: hasData ? "pointer" : "not-allowed",
        }}
        onClick={() => {
          if (!hasData) return; // prevent click if no data
          setBreakdownData(parsed);
          setIsGroupedDetail(false);
          setOpenBreakdown(true);
        }}
      >
        {params.value}
      </span>
    );
  },
},

    {
      field: "discountpromotion",
      headerName: "Discount & Promotion",
      width: 200,
    },
    {
      field: "discount_usd",
      headerName: "Discount (USD)",
      width: 150,
    },
    // { field: "discrepency", headerName: "Discrepancy", width: 150 },
    {
      field: "discrepency",
      headerName: "Discrepancy",
      width: 150,
      renderCell: (params) => (
        <Tooltip title="View detail">
          <span
            onClick={() => {
              // console.log("row, ", params.row)
              const { service_id, location_id_y, charge_type, invoice_id } = params.row;
                        // console.log("Discrepancy Click - Row:", params.row);

              fetchDiscrepancyDetails(service_id, location_id_y, charge_type, invoice_id, params.row.id);
            }}
            style={{
              color: "blue",
              textDecoration: "underline",
              cursor: "pointer",
            }}
          >
            {/* {params.value} */}
            {loadingDisRowId === params.row.id ? (
          <CircularProgress size={16} />
        ) : (
          params.value
        )}
          </span>
        </Tooltip>
      ),
    },
    {
      field: "taxessurcharges",
      headerName: "Taxes & Surcharges (USD)",
      width: 200,
    },
    {
      field: "taxes_usd",
      headerName: "Taxes (USD)",
      width: 150,
    },
    {
      field: "total_usd",
      headerName: "Total Amount",
      width: 150,
    },
    {
      field: "conversion_rate",
      headerName: "Conversion Rate",
      width: 150,
      renderCell: (params) => {
        const val = params.value;
        if (val === null || val === undefined || val === "N/A" || val === "") return "N/A";
        const num = Number(val);
        if (isNaN(num)) return val;
        const formatted = parseFloat(num.toFixed(3)).toString();
        return (
          <Tooltip title={String(val)} arrow placement="top">
            <span style={{ cursor: "pointer", borderBottom: "1px dashed #7C2EA0" }}>
              {formatted}
            </span>
          </Tooltip>
        );
      }
    },
    {
      field: "converted_total_usd",
      headerName: "Total USD",
      width: 150,
    },
    { field: "loc_name", headerName: "Location", width: 150 },
    // { field: "location_id_y", headerName: "Location ID", width: 150 },
    {
      field: "location_id_y",
      headerName: "Location ID",
      width: 150,
      renderCell: (params) => (
        <Tooltip title="View invoice detail">
          <span
            onClick={() => fetchInvoiceDetailsLocation(params.value, params.row.id)}
            style={{
              color: "blue",
              textDecoration: "underline",
              cursor: "pointer",
            }}
          >
            {/* {params.value} */}
             {loadingLocRowId === params.row.id ? (
          <CircularProgress size={16} />
        ) : (
          params.value
        )}
          </span>
        </Tooltip>
      ),
    },
    { field: "country", headerName: "Country", width: 150 },
    { field: "page_no", headerName: "Page No", width: 150 },
  ];

    // Filter discrepancyData if search_for param exists
// Filter discrepancyData if search_for param exists
const getFilteredDiscrepancyData = () => {
  const searchFor = searchParams.get('search_for');
  
  // Check for both spellings (discrepency and discrepancy)
  if ((searchFor === 'discrepency' || searchFor === 'discrepancy') && discrepancyData) {
    const filtered = discrepancyData.filter(invoice => {
      const discrepancy = parseFloat(invoice?.discrepancy || 0);
      return discrepancy !== 0;
    });
    return filtered;
  }
  
  // Otherwise return all data
  return discrepancyData;
};
  const filteredData = getFilteredDiscrepancyData();

  const rows = filteredData?.map((invoice, index) => ({
    id: index + 1,
    service_id: invoice?.service_id || "N/A",
    invoice_id: invoice?.invoice_id || "N/A",
    service_name_y:
      invoice?.service_name ||
      invoice?.service_name_x ||
      invoice?.service_name_y ||
      "N/A",
    service_description: String(
      invoice?.service_description ||
        invoice?.service_description_x ||
        invoice?.service_description_y ||
        "N/A"
    ).replace(/\n/g, " "),
    contract_amount_breakdown: invoice.contract_amount_breakdown,
    doc_id: invoice?.doc_id || "N/A",
    missing_sof: invoice?.missing_sof,
    matched_doc_id: invoice?.matched_doc_id || "-",
    matched_source: invoice?.matched_source || "N/A",
    sof_status: invoice?.sof_status || "N/A",
    charge_period: invoice?.charge_period || "N/A",
    charge_type:
      invoice?.charge_type ||
      invoice?.charge_type_x ||
      invoice?.charge_type_y ||
      "N/A",
    amount: invoice?.amount || "N/A",
    // contract_amount: isNaN(invoice?.contract_amount) ? "N/A" : invoice?.contract_amount,
    // discountpromotion: invoice?.["discount_&_promotion"] || "N/A",
    // discrepency: isNaN(invoice?.discrepancy) ? "N/A" : invoice.discrepancy?.toFixed(2),
    // taxessurcharges: invoice?.["taxes_&_surcharges"] || "N/A",
    // total_usd: invoice?.total_usd || "N/A",
    // amount: invoice?.amount
    //   ? Number(invoice.amount).toLocaleString(undefined, {
    //       minimumFractionDigits: 2,
    //       maximumFractionDigits: 2,
    //     })
    //   : "N/A",
      amount_usd: invoice?.amount_usd || "N/A",
    contract_amount: invoice?.contract_amount
      ? Number(invoice.contract_amount).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      : "N/A",
    discountpromotion: invoice?.["discount_&_promotion"]
      ? Number(invoice["discount_&_promotion"]).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      : "N/A",
    discount_usd: invoice?.discount_usd !== undefined && invoice?.discount_usd !== null
      ? Number(invoice.discount_usd).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      : "N/A",
    discrepency: invoice?.discrepancy
      ? Number(invoice.discrepancy).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      : 0,
    taxessurcharges: invoice?.["taxes_&_surcharges"]
      ? Number(invoice["taxes_&_surcharges"]).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      : "N/A",
    taxes_usd: invoice?.taxes_usd !== undefined && invoice?.taxes_usd !== null
      ? Number(invoice.taxes_usd).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      : "N/A",
    total_usd: invoice?.total_usd
      ? `${invoice?.currency} ${Number(invoice.total_usd).toLocaleString(
          undefined,
          {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }
        )}`
      : "N/A",
    loc_name: invoice?.loc_name || "N/A",
    location_id_y:
      invoice?.location_id ||
      invoice?.location_id_x ||
      invoice?.location_id_y ||
      "N/A",
    country: invoice?.country || "N/A",
    page_no: invoice?.page_no || "N/A",
    conversion_rate: invoice.conversion_rate,
    converted_total_usd: invoice.converted_total_usd,
  }));

  const circuitColumns = [
    { field: "circuit_id", headerName: "Circuit ID", width: 150 },
    { field: "amount_sum", headerName: "Amount", width: 150 },
    // { field: "amount_usd_sum", headerName: "Amount USD Sum", width: 150 },
    // { field: "converted_total_usd", headerName: "Converted Total USD", width: 180 },
    { field: "discount_and_promotion", headerName: "Discount & Promotion", width: 180 },
    { field: "taxes_and_surcharges", headerName: "Taxes & Surcharges", width: 180 },
    { field: "total_usd", headerName: "Total USD", width: 150 },
  ];

  const circuitRows = circuitTotals?.map((item, index) => ({
    ...item,
    id: index + 1,
    amount_sum: item.amount_sum
      ? Number(item.amount_sum).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      : "N/A",
    // amount_usd_sum: item.amount_usd_sum
    //   ? Number(item.amount_usd_sum).toLocaleString(undefined, {
    //       minimumFractionDigits: 2,
    //       maximumFractionDigits: 2,
    //     })
    //   : "N/A",
    // converted_total_usd: item.converted_total_usd
    //   ? Number(item.converted_total_usd).toLocaleString(undefined, {
    //       minimumFractionDigits: 2,
    //       maximumFractionDigits: 2,
    //     })
    //   : "N/A",
    discount_and_promotion: item.discount_and_promotion
      ? Number(item.discount_and_promotion).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      : 0,
    taxes_and_surcharges: item.taxes_and_surcharges
      ? Number(item.taxes_and_surcharges).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      : 0,
    total_usd: item.total_usd
      ? Number(item.total_usd).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      : "N/A",
  }));

  const groupedColumns = [
    { 
      field: "service_id", 
      headerName: "Service ID", 
      width: 150,
      renderCell: (params) => (
        <span 
          onClick={() => handleClassificationClick(params.row.service_id, params.row.invoice_id)}
          style={{ cursor: "pointer", borderBottom: "1px dashed #7C2EA0", color: "#1976d2" }}
        >
          {params.value || "-"}
        </span>
      )
    },
    { field: "invoice_id", headerName: "Invoice ID", width: 150 },
    { field: "doc_id", headerName: "Document ID", width: 150 },
    { field: "invoice_currency", headerName: "Invoice Currency", width: 140 },
    { field: "invoice_local_amount", headerName: "Invoice Local Amount", width: 180 },
    { field: "invoice_rate_amount_usd", headerName: "Invoice Rate Amount (USD)", width: 210 },
    { field: "invoice_discount_usd", headerName: "Invoice Discount (USD)", width: 200 },
    { field: "amount_usd", headerName: "Amount (USD)", width: 150 },
    {
      field: "discrepancy_classification",
      headerName: "Classification",
      width: 180,
      renderCell: (params) => {
        return (
          <Tooltip title={params.row.discrepancy_classification_description || ""} arrow placement="top">
            <span style={{ cursor: params.row.discrepancy_classification_description ? "help" : "default", borderBottom: params.row.discrepancy_classification_description ? "1px dashed #7C2EA0" : "none" }}>
              {params.value ? params.value.replace(/_/g, ' ') : "-"}
            </span>
          </Tooltip>
        );
      },
    },
    {
      field: "contract_amount",
      headerName: "Contract Amount",
      width: 150,
      renderCell: (params) => {
        const hasData =
          (params.row.contract_amount_breakdown?.sof_items?.length > 0) ||
          (params.row.contract_amount_breakdown?.amendment_items?.length > 0);

        return (
          <span
            style={{
              color: hasData ? "blue" : "gray",
              textDecoration: hasData ? "underline" : "none",
              cursor: hasData ? "pointer" : "not-allowed",
            }}
            onClick={() => {
              if (!hasData) return;
              const rawBreakdown = {
                sof: params.row.contract_amount_breakdown.sof_items || [],
                amendment: params.row.contract_amount_breakdown.amendment_items || [],
                // The SOF table below lists an MRC and an NRC column per line, but the
                // contract amount normally uses only ONE of them, and may then be scaled
                // for a part-month or have metered usage added. Without these fields the
                // dialog cannot explain how the Contract Amount was reached.
                contract_calculation: params.row.contract_amount_breakdown.contract_calculation || null,
                total_sof: params.row.contract_amount_breakdown.total_sof,
                total_amendment: params.row.contract_amount_breakdown.total_amendment,
                contract_amount: params.row.contract_amount,
                discrepancy_explanation: params.row.discrepancy_explanation || null,
              };
              setBreakdownData(rawBreakdown);
              setIsGroupedDetail(true);
              setOpenBreakdown(true);
            }}
          >
            {params.value}
          </span>
        );
      },
    },
    { field: "discrepancy_amount", headerName: "Discrepancy Amount", width: 150 },
  ];

  const groupedRows = groupedServices?.map((item, index) => ({
    ...item,
    id: index + 1,
    invoice_currency: item.invoice_currency || "N/A",
    invoice_local_amount: item.invoice_local_amount
      ? Number(item.invoice_local_amount).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      : "N/A",
    invoice_rate_amount_usd: item.invoice_rate_amount_usd !== null && item.invoice_rate_amount_usd !== undefined
      ? Number(item.invoice_rate_amount_usd).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      : "N/A",
    invoice_discount_usd: item.invoice_discount_usd !== null && item.invoice_discount_usd !== undefined
      ? Number(item.invoice_discount_usd).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      : "N/A",
    amount_usd: item.amount_usd
      ? Number(item.amount_usd).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      : "N/A",
    contract_amount: item.contract_amount
      ? Number(item.contract_amount).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      : "N/A",
    discrepancy_amount: item.discrepancy_amount
      ? Number(item.discrepancy_amount).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      : "0.00",
  }));

const handleDownloadCSV = () => {
  const csvRows = [];
  
  // Determine which tab is active based on tabValue and dataset availability
  const activeTabs = ["Line Items"];
  if (circuitTotals && circuitTotals.length > 0) activeTabs.push("Circuit Totals");
  if (groupedServices && groupedServices.length > 0) activeTabs.push("Grouped Services");

  const currentTab = activeTabs[tabValue];

  if (currentTab === "Line Items") {
    const headers = [
      "Sno",
      "Service ID",
      "Service Name",
      "Service Description",
      "Document ID",
      "Matched Doc ID",
      "Matched Source",
      "SOF Status",
      "Charge Period",
      "Charge Type",
      "Amount",
      "Amount (USD)",
      "Contract Amount",
      "Discount & Promotion",
      "Discount (USD)",
      "Discrepancy",
      "Taxes & Surcharges (USD)",
      "Taxes (USD)",
      "Total Amount",
      "Conversion Rate",
      "Total (USD)",
      "Location",
      "Location ID",
      "Country",
      "Page No",
    ];
    csvRows.push(headers.join(","));

    filteredData?.forEach((invoice, index) => {
      const row = [
        index + 1,
        invoice?.service_id,
        invoice?.service_name || invoice?.service_name_x || invoice?.service_name_y,
        invoice?.service_description,
        invoice?.doc_id,
        invoice?.matched_doc_id,
        invoice?.matched_source,
        invoice?.sof_status,
        invoice?.charge_period,
        invoice?.charge_type,
        invoice?.amount,
        invoice?.amount_usd,
        invoice?.contract_amount || invoice?.invoice?.contract_amount,
        invoice?.["discount_&_promotion"],
        invoice?.discount_usd,
        isNaN(invoice?.discrepancy) ? "" : Number(invoice.discrepancy).toFixed(2),
        invoice?.["taxes_&_surcharges"],
        invoice?.taxes_usd,
        invoice?.total_usd ? `${invoice.currency} ${invoice.total_usd}` : "",
        invoice?.conversion_rate,
        invoice?.converted_total_usd,
        invoice?.loc_name,
        invoice?.location_id || invoice?.location_id_x || invoice?.location_id_y,
        invoice?.country,
        invoice?.page_no,
      ].map((val) => {
        const clean = String(val ?? "").replace(/"/g, '""').replace(/[\r\n]+/g, " ");
        return `"${clean}"`;
      });
      csvRows.push(row.join(","));
    });
  } else if (currentTab === "Circuit Totals") {
    const headers = [
      "Sno",
      "Circuit ID",
      "Amount",
      "Discount & Promotion",
      "Taxes & Surcharges",
      "Total USD",
    ];
    csvRows.push(headers.join(","));

    circuitTotals?.forEach((item, index) => {
      const row = [
        index + 1,
        item?.circuit_id,
        item?.amount_sum,
        item?.discount_and_promotion,
        item?.taxes_and_surcharges,
        item?.total_usd,
      ].map((val) => {
        const clean = String(val ?? "").replace(/"/g, '""').replace(/[\r\n]+/g, " ");
        return `"${clean}"`;
      });
      csvRows.push(row.join(","));
    });
  } else if (currentTab === "Grouped Services") {
    const headers = [
      "Sno",
      "Service ID",
      "Invoice ID",
      "Document ID",
      "Invoice Currency",
      "Invoice Local Amount",
      "Invoice Rate Amount (USD)",
      "Invoice Discount (USD)",
      "Amount (USD)",
      "Classification",
      "Classification Description",
      "Contract Amount",
      "Discrepancy Amount",
    ];
    csvRows.push(headers.join(","));

    groupedServices?.forEach((item, index) => {
      const row = [
        index + 1,
        item?.service_id,
        item?.invoice_id,
        item?.doc_id,
        item?.invoice_currency,
        item?.invoice_local_amount,
        item?.invoice_rate_amount_usd,
        item?.invoice_discount_usd,
        item?.amount_usd,
        item?.discrepancy_classification ? item.discrepancy_classification.replace(/_/g, ' ') : "",
        item?.discrepancy_classification_description,
        item?.contract_amount,
        item?.discrepancy_amount,
      ].map((val) => {
        const clean = String(val ?? "").replace(/"/g, '""').replace(/[\r\n]+/g, " ");
        return `"${clean}"`;
      });
      csvRows.push(row.join(","));
    });
  }

  const csvContent = csvRows.join("\n");
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);

  // Use a unique filename for each tab
  const tabSuffix = currentTab.replace(/\s+/g, "_");
  const fileName = `Invoice_${invoiceNo || "data"}_${tabSuffix}.csv`;

  link.setAttribute("href", url);
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  // Revoke blob URL to free memory
  URL.revokeObjectURL(url);
};

  return (
    <div>
<Toaster position="top-right" reverseOrder={false}/>
      <Modal
        style={{ zIndex: 1400 }}
        open={open}
        onClose={(e, reason) => {
          if (reason !== "backdropClick") {
            handleClose();
          }
        }}
        disableBackdropClick
        disableEscapeKeyDown
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "90px",
            left: "50%",
            transform: "translateX(-50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            width: "90%",
            height: "73%",
            maxHeight: "calc(100vh - 120px)",
            maxWidth: "1200px",
            borderRadius: 2,
            overflowY: "auto",
            zIndex: 10, 
          }}
        >
          <>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "10px",
              }}
            >
              <Typography
                id="modal-title"
                variant="h6"
                component="h2"
                sx={{ fontSize: "24px" }}
              >
                Discrepancy Details
              </Typography>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: "20px",
                }}
              >
                <button
                  onClick={handleDownloadCSV}
                  style={{
                    background: "#4CAF50",
                    color: "#fff",
                    padding: "10px",
                    border: "none",
                    cursor: "pointer",
                  }}
                >
                  Download CSV
                </button>
                <IoClose
                  size={24}
                  onClick={() => {
                    setOpen(false);
                  }}
                />
              </div>
            </div>

            {(circuitTotals && circuitTotals.length > 0) || (groupedServices && groupedServices.length > 0) ? (
              <>
                <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                  <Tabs
                    value={tabValue}
                    onChange={handleTabChange}
                    aria-label="discrepancy details tabs"
                  >
                    <Tab label="Line Items" />
                    {circuitTotals && circuitTotals.length > 0 && (
                      <Tab label="Circuit Totals" />
                    )}
                    {groupedServices && groupedServices.length > 0 && (
                      <Tab label="Grouped Services" />
                    )}
                  </Tabs>
                </Box>
                <TabPanel value={tabValue} index={0}>
                  {loading ? (
                    <div
                      style={{
                        background: "#c3c3c340",
                        display: "flex",
                        marginBottom: "10px",
                        padding: "10px",
                        borderRadius: "5px",
                        flexDirection: "column",
                      }}
                    >
                      Loading...
                    </div>
                  ) : (
                    <div
                      style={{
                        background: "#c3c3c340",
                        display: "flex",
                        marginBottom: "10px",
                        padding: "10px",
                        borderRadius: "5px",
                        flexDirection: "column",
                      }}
                    >
                      {invoiceDetailsDisc?.length === 0 ? (
                        <p>
                          Click on discrepancy amount to preview recent invoices
                          details.
                        </p>
                      ) : invoiceDetailsDisc &&
                        invoiceDetailsDisc.length > 0 ? (
                        invoiceDetailsDisc?.map((invoice, index) => (
                          <div
                            key={index}
                            style={{
                              marginBottom: "5px",
                              borderBottom: "1px solid #00000080",
                              paddingBottom: "5px",
                            }}
                          >
                            <strong>{index + 1} - </strong>

                            <span style={{ marginLeft: "10px" }}>
                              {Object.entries(invoice).map(
                                ([key, value], i, arr) => {
                                  const formattedValue =
                                    ["amount", "total_usd"].includes(key) &&
                                    !isNaN(value)
                                      ? Number(value).toLocaleString(
                                          undefined,
                                          {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                          }
                                        )
                                      : value;

                                  return (
                                    <span
                                      key={i}
                                      style={{ fontSize: "11.5px" }}
                                    >
                                      <strong>
                                        {fieldMappings[key] || key}:
                                      </strong>{" "}
                                      {formattedValue}
                                      {i < arr.length - 1 && ", "}
                                    </span>
                                  );
                                }
                              )}
                            </span>
                          </div>
                        ))
                      ) : (
                        <p>No detail available.</p>
                      )}
                    </div>
                  )}
                  <DataTable columns={columns} rows={rows} />
                </TabPanel>
                {circuitTotals && circuitTotals.length > 0 && (
                  <TabPanel value={tabValue} index={1}>
                    <DataTable columns={circuitColumns} rows={circuitRows} />
                  </TabPanel>
                )}
                {groupedServices && groupedServices.length > 0 && (
                  <TabPanel
                    value={tabValue}
                    index={circuitTotals && circuitTotals.length > 0 ? 2 : 1}
                  >
                    <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
                      <Button
                        variant="outlined"
                        color="error"
                        onClick={() => setUnresolvedContractModalOpen(true)}
                        sx={{ fontWeight: "bold", textTransform: "none" }}
                      >
                        Due To Missing Contract
                      </Button>
                    </Box>
                    <DataTable columns={groupedColumns} rows={groupedRows} />
                  </TabPanel>
                )}
              </>
            ) : (
              <>
                {loading ? (
                  <div
                    style={{
                      background: "#c3c3c340",
                      display: "flex",
                      marginBottom: "10px",
                      padding: "10px",
                      borderRadius: "5px",
                      flexDirection: "column",
                    }}
                  >
                    Loading...
                  </div>
                ) : (
                  <div
                    style={{
                      background: "#c3c3c340",
                      display: "flex", // Changed to flex
                      marginBottom: "10px", // Added marginBottom
                      padding: "10px", // Added padding
                      borderRadius: "5px", // Added borderRadius
                      flexDirection: "column", // Added flexDirection
                    }}
                  >
                    {invoiceDetailsDisc?.length === 0 ? (
                      <p>
                        Click on discrepancy amount to preview recent invoices
                        details.
                      </p>
                    ) : invoiceDetailsDisc && invoiceDetailsDisc.length > 0 ? (
                      invoiceDetailsDisc?.map((invoice, index) => (
                        <div
                          key={index}
                          style={{
                            marginBottom: "5px",
                            borderBottom: "1px solid #00000080",
                            paddingBottom: "5px",
                          }}
                        >
                          <strong>{index + 1} - </strong>

                          <span style={{ marginLeft: "10px" }}>
                            {Object.entries(invoice).map(
                              ([key, value], i, arr) => {
                                const formattedValue =
                                  ["amount", "total_usd"].includes(key) &&
                                  !isNaN(value)
                                    ? Number(value).toLocaleString(undefined, {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      })
                                    : value;

                                return (
                                  <span key={i} style={{ fontSize: "11.5px" }}>
                                    <strong>
                                      {fieldMappings[key] || key}:
                                    </strong>{" "}
                                    {formattedValue}
                                    {i < arr.length - 1 && ", "}
                                  </span>
                                );
                              }
                            )}
                          </span>
                        </div>
                      ))
                    ) : (
                      <p>No detail available.</p>
                    )}
                  </div>
                )}
                <DataTable columns={columns} rows={rows} />
              </>
            )}
          </>
        </Box>
      </Modal>
      <MoreDetailsModal
        open={moreModalOpen}
        handleClose={() => setMoreModalOpen(false)}
        invoiceDetails={invoiceDetails}
      />
      <MoreDetailsModalLocation
        open={moreModalOpenLocation}
        handleClose={() => setMoreModalOpenLocation(false)}
        invoiceDetails={invoiceDetailsLocation}
      />


    {/* Breakdown Modal */}
    <ContractAmountBreakdownModal 
      open={openBreakdown}
      onClose={() => setOpenBreakdown(false)}
      breakdownData={breakdownData}
    />
      <MatchedSofDocsModal
        open={sofModalOpen}
        onClose={() => setSofModalOpen(false)}
        data={sofModalData}
        isLoading={sofModalLoading}
      />
      {unresolvedContractModalOpen && (
        <GroupedServicesDetailsModal
          open={unresolvedContractModalOpen}
          onClose={() => setUnresolvedContractModalOpen(false)}
          initialFilters={{ invoice_id: invoiceNo }}
          searchFor="ARTIFACT_UNRESOLVED_CONTRACT"
        />
      )}
    </div>
  );
};

export default Discrepancy;
